import { useTranslation } from 'react-i18next';

import { Form } from '@arco-design/web-react';

import { CapacitySlider, CapacitySliderRow } from '@/components/CapacitySlider';

import { isVendorQuantityOptional } from '../../utils/postPaidPricing';
import { DEFAULT_QUANTITY_UNITS, useWatchedQuantityUnit } from '../quantityUnit';
import { ReclaimPolicyFormField, isReclaimPolicyLocked } from '../reclaimPolicyField';
import { StorageClassFormField } from '../storageClassField';
import { DISK_PRICING_FIELD } from '../vendorDevice';
import { DISK_SIZE_MARK_COUNT, DISK_SIZE_MAX_GI, DISK_SIZE_MIN_GI } from './constants';
import type { DiskVolumeFieldsProps } from './types';

/** 磁盘通用表单项：回收策略 + 存储类（含计价）+ 容量 */
export function DiskVolumeFields({
  form,
  diskSizeField = 'diskSize',
  storageClassField = 'storageClass',
  reclaimPolicyField = 'reclaimPolicy',
  enabled = true,
  billModelId,
  deploymentTypeId,
  paymentTiming,
  skuType,
  resourceEditMode,
  resourceCode,
  getPopupContainer,
  markCount = DISK_SIZE_MARK_COUNT,
  diskSizeInitialValue,
  showReclaimPolicy = true,
  selectionReadOnly = false,
}: DiskVolumeFieldsProps) {
  const { t } = useTranslation();
  const skipSizeRequired = isVendorQuantityOptional({ billModelId, paymentTiming, skuType, resourceEditMode });
  const quantityUnit = useWatchedQuantityUnit(form, billModelId ? DISK_PRICING_FIELD : undefined, DEFAULT_QUANTITY_UNITS.disk, {
    lockDisplayToDefault: true,
  });
  /** SKU / 下单：隐藏回收策略并固定 Delete；直建可改 */
  const reclaimLocked = isReclaimPolicyLocked(resourceEditMode);

  return (
    <>
      {showReclaimPolicy ? (
        <ReclaimPolicyFormField
          form={form}
          field={reclaimPolicyField}
          enabled={enabled}
          disabled={selectionReadOnly}
          lockedToDelete={reclaimLocked}
          getPopupContainer={getPopupContainer}
        />
      ) : null}
      <StorageClassFormField
        form={form}
        field={storageClassField}
        enabled={enabled}
        billModelId={billModelId}
        deploymentTypeId={deploymentTypeId}
        resourceCode={resourceCode}
        disabled={selectionReadOnly}
        getPopupContainer={getPopupContainer}
      />
      <CapacitySliderRow unit={quantityUnit}>
        <Form.Item
          field={diskSizeField}
          label={t('common:capacity')}
          initialValue={diskSizeInitialValue}
          rules={skipSizeRequired ? undefined : [{ required: true, message: t('common:validate.not-empty') }]}
        >
          <CapacitySlider min={DISK_SIZE_MIN_GI} max={DISK_SIZE_MAX_GI} markCount={markCount} translateUnit={false} unit={quantityUnit} />
        </Form.Item>
      </CapacitySliderRow>
    </>
  );
}
